import * as React from 'react';

interface IToolCallLineProps {
  /**
   * The model-supplied, user-facing goal for one tool call, e.g. "Looking for
   * your recent transactions". Written as a verb-led fragment; this component
   * appends the trailing ellipsis.
   */
  goal: string;
}

/**
 * A single tool-activity line: small gray text with a trailing ellipsis,
 * rendered OUTSIDE any speech bubble. Shows what the assistant is doing in the
 * background while a tool runs, and persists in rehydrated history. Flush-left
 * so it lines up with the assistant's full-width messages.
 */
export default function ToolCallLine({ goal }: IToolCallLineProps): React.ReactElement {
  return <div className="text-tertiary text-2xs">{goal}&hellip;</div>;
}
